import { render, staticRenderFns } from "./StatsGlobals.vue?vue&type=template&id=56d590e9&"
import script from "./StatsGlobals.vue?vue&type=script&lang=js&"
export * from "./StatsGlobals.vue?vue&type=script&lang=js&"
import style0 from "./StatsGlobals.vue?vue&type=style&index=0&id=56d590e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports